import React from "react";
import styled from "styled-components";
import { alpha } from "@ui/styles/utils";
import { row } from "@ui/components/layout";

interface StepBubbleProps extends React.HTMLAttributes<HTMLDivElement> {
	steps: number;
	currentStep: number;
}

export const StepBubble: React.FC<StepBubbleProps> = ({ steps, currentStep, ...htmlProps }) => {
	return (
		<Container {...htmlProps}>
			{[...Array(steps)].map((_, i) => (
				<Bubble key={i} active={currentStep === i} />
			))}
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	${row(13, "center", "center")};
`;

const Bubble = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "active",
})<{ active: boolean }>`
	width: 12px;
	height: 12px;
	border-radius: 50%;
	background-color: ${({ active, theme }) => (active ? theme.colors.secondary : alpha(theme.colors.secondary, 0.5))};
`;
